'use client'

import Script from 'next/script'

export const ContactForm = () => {
  return (
    <>
      {/* Tally Contact Form Embed */}
      <iframe
        data-tally-src="https://tally.so/embed/Zj52gv?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
        loading="lazy"
        width="100%"
        height="1100"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        title="資料請求フォーム"
      />

      {/* Tally Widget Script */}
      <Script src="https://tally.so/widgets/embed.js" strategy="lazyOnload" />
    </>
  )
}
